import { ikTransform, buildSrcSet } from "@/lib/media";

export default function MediaImg({ src, alt = "", width, height, sizes = "100vw", eager = false, className = "", testid, onError }) {
  if (!src) return null;
  const srcSet = buildSrcSet(src);
  return (
    <img
      src={ikTransform(src, 800)}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      {...(eager ? { fetchPriority: "high" } : {})}
      {...(width ? { width } : {})}
      {...(height ? { height } : {})}
      onError={onError}
      className={className}
      data-testid={testid}
    />
  );
}
